import { useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import s from "./discount-setting.module.scss";
import classNames from "classnames";
import ReactRangeSliderInput from "react-range-slider-input";
import { Button } from "@shared/ui/button/button";
import { SettingRow } from "../setting-row/setting-row";
import { useUpdateDiscount } from "@entities/teacher/api/useUpdateDiscount";
import "react-range-slider-input/dist/style.css";

export const DiscountSetting = ({ profile }) => {
	const { mutate: updateDiscount } = useUpdateDiscount();

	const isFree = useMemo(
		() => !!profile?.free_first_lesson || profile?.first_lesson_discount === 100,
		[profile]
	);

	const initialValue = useMemo(
		() => [0, isFree ? 100 : (profile?.first_lesson_discount || 0)],
		[isFree, profile?.first_lesson_discount]
	);

	const methods = useForm({
		mode: "onChange",
		defaultValues: {
			discount_value: initialValue,
		},
	});

	const { formState, handleSubmit, watch, reset, control } = methods;

	useEffect(() => {
		reset({
			discount_value: initialValue,
		});
	}, [initialValue, reset]);

	const discountValue = watch("discount_value");
	const currentValue = discountValue?.[1] ?? 0;

	const onSubmit = handleSubmit((data) => {
		const value = data.discount_value[1];
		updateDiscount({
			free_first_lesson: value === 100,
			first_lesson_discount: value,
		});
	});

	const renderValueLabel = () => {
		if (currentValue === 100) {
			return (
				<div className={s.discountHeader}>
					<span className={classNames(s.discountBadge, s.discountBadgeFree)}>Бесплатно</span>
					<span className={s.discountHint}>первое занятие</span>
				</div>
			);
		}
		if (currentValue === 0) {
			return (
				<div className={s.discountHeader}>
					<span className={s.discountBadge}>0%</span>
					<span className={s.discountHint}>без скидки</span>
				</div>
			);
		}
		return (
			<div className={s.discountHeader}>
				<span className={s.discountBadge}>-{currentValue}%</span>
				<span className={s.discountHint}>скидка на первое занятие</span>
			</div>
		);
	};

	return (
		<SettingRow
			title="Скидка на первое занятие"
			subtitle="Выберите размер скидки. 100% — бесплатное первое занятие."
			withoutBorders
		>
			<div className={s.discountForm}>
				{renderValueLabel()}
				<div className={s.sliderWrapper}>
					<Controller
						name="discount_value"
						control={control}
						render={({ field }) => (
							<ReactRangeSliderInput
								className={classNames(s.rangeSlider)}
								rangeSlideDisabled={true}
								min={0}
								max={100}
								step={5}
								thumbsDisabled={[true, false]}
								value={field.value}
								onInput={(event) =>
									event[1] > 70
										? field.onChange([0, 100])
										: field.onChange(event)
								}
							/>
						)}
					/>
					<div className={s.sliderLabels}>
						<span>0%</span>
						<span>Бесплатно</span>
					</div>
				</div>
				<div className={s.discountActions}>
					<Button
						label="Сохранить"
						onClick={onSubmit}
						size="small"
						className={s.saveButton}
						disabled={!formState.isValid || !formState.isDirty}
					/>
				</div>
			</div>
		</SettingRow>
	);
};
